module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showbanner),
      expression: "showbanner"
    }],
    staticClass: "main_container findneirong12"
  }, [_c('div', {
    staticClass: "fuji",
    on: {
      "click": function($event) {
        _vm.show3 = !_vm.show3
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "sanjiao",
    staticStyle: {
      "position": "absolute",
      "right": "-10px",
      "top": "-10px"
    }
  })]), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show3),
      expression: "show3"
    }],
    staticStyle: {
      "padding": "0 12px"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showbanner),
      expression: "showbanner"
    }],
    staticClass: "find"
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    staticStyle: {
      "display": "flex",
      "margin-top": "10px",
      "height": "55px"
    },
    attrs: {
      "inline": true,
      "model": _vm.formInline
    }
  }, [_c('el-form-item', {
    staticClass: "demo-item",
    staticStyle: {
      "display": "flex",
      "width": "100%"
    },
    attrs: {
      "label": "品牌选择："
    }
  }, [_c('el-select', {
    staticClass: "demo-select",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.brandId),
      callback: function($$v) {
        _vm.brandId = $$v
      },
      expression: "brandId"
    }
  }, _vm._l((_vm.pinpaiptions), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "demo-item",
    staticStyle: {
      "display": "flex",
      "width": "100%",
      "margin-left": "30px"
    },
    attrs: {
      "label": "销售类型："
    }
  }, [_c('el-select', {
    staticClass: "demo-select",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择销售类型"
    },
    model: {
      value: (_vm.showtype),
      callback: function($$v) {
        _vm.showtype = $$v
      },
      expression: "showtype"
    }
  }, _vm._l((_vm.moretype), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "demo-item",
    staticStyle: {
      "display": "flex",
      "width": "100%",
      "margin-left": "30px"
    },
    attrs: {
      "label": "商品类型："
    }
  }, [_c('el-select', {
    staticClass: "demo-select",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择商品类型"
    },
    model: {
      value: (_vm.CommodityId),
      callback: function($$v) {
        _vm.CommodityId = $$v
      },
      expression: "CommodityId"
    }
  }, _vm._l((_vm.Commoditytypes), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-form', {
    staticClass: "demo-form-inline2",
    staticStyle: {
      "display": "flex",
      "height": "55px"
    },
    attrs: {
      "inline": true,
      "model": _vm.formInline
    }
  }, [_c('el-form-item', {
    staticClass: "demo-item",
    staticStyle: {
      "display": "flex",
      "width": "100%"
    },
    attrs: {
      "label": "商品分类："
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择",
      "options": _vm.options1,
      "filterable": "",
      "change-on-select": ""
    },
    on: {
      "change": _vm.handleChange1
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "100%",
      "margin-left": "30px"
    },
    attrs: {
      "label": "所属城市："
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择城市",
      "options": _vm.options,
      "filterable": "",
      "change-on-select": ""
    },
    on: {
      "change": _vm.handleChange
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "100%",
      "margin-left": "30px"
    },
    attrs: {
      "label": "商品名称："
    }
  }, [_c('el-input', {
    staticClass: "findgoods",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入查询商品名称"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showbanner),
      expression: "showbanner"
    }],
    staticStyle: {
      "float": "right",
      "margin-bottom": "10px",
      "margin-top": "-20px",
      "margin-right": "10px"
    }
  }, [_c('el-button', {
    staticClass: "Establish",
    on: {
      "click": function($event) {
        _vm.Search()
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    staticClass: "Reset",
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_vm._v("重置")])], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "banner_table"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showbanner),
      expression: "showbanner"
    }]
  }, [_c('p', {
    staticClass: "tittle"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "5px",
      "display": "inline-block",
      "height": "30px",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.left_span()
      }
    }
  }, [_vm._v("已配置")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "25px",
      "display": "inline-block",
      "height": "30px",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.right_span()
      }
    }
  }, [_vm._v("未配置")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.span1_show),
      expression: "span1_show"
    }],
    staticClass: "wei"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.span2_show),
      expression: "span2_show"
    }],
    staticClass: "yi"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shopshow),
      expression: "shopshow"
    }],
    staticClass: "noshop"
  }, [_vm._v("请搜索添加商品")]), _vm._v(" "), [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tableshow),
      expression: "tableshow"
    }]
  }, [_c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Configured),
      expression: "Configured"
    }],
    staticStyle: {
      "width": "98%",
      "height": "auto"
    },
    attrs: {
      "data": _vm.tableData,
      "align": "center",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "date",
      "type": "index",
      "align": "center",
      "label": "ID",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "align": "center",
      "label": "主图/商品名称",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticStyle: {
            "width": "50px",
            "height": "33px",
            "float": "left",
            "margin-left": "10px"
          },
          attrs: {
            "data-img": scope.row.FImgs,
            "src": scope.row.FImgs
          },
          on: {
            "click": _vm.$imgPreview
          }
        }), _vm._v(" "), _c('span', {
          staticStyle: {
            "display": "inline-block",
            "float": "left",
            "margin": "10px 0 0 5px",
            "width": "200px",
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.Title
          }
        }, [_vm._v(_vm._s(scope.row.Title))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "GoodModelCode",
      "align": "center",
      "label": "商品编码",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.GoodModelCode
          }
        }, [_vm._v(_vm._s(scope.row.GoodModelCode))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "amount2",
      "align": "center",
      "label": "所属城市"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.ProvinceName + '-' + scope.row.CityName
          }
        }, [_vm._v(_vm._s(scope.row.ProvinceName) + "-" + _vm._s(scope.row.CityName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "TzrPrice",
      "width": "130px",
      "align": "center",
      "label": "销售价格（元）"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": '￥' + scope.row.TzrPrice
          }
        }, [_vm._v("￥" + _vm._s(scope.row.TzrPrice))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "BrandName",
      "align": "center",
      "label": "品牌名称"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.BrandName
          }
        }, [_vm._v(_vm._s(scope.row.BrandName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "align": "center",
      "label": "商品分类"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.GoodsTypeName + '-' + scope.row.GoodsBrandTypeName
          }
        }, [_vm._v(_vm._s(scope.row.GoodsTypeName) + "-" + _vm._s(scope.row.GoodsBrandTypeName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "GoodActiveName",
      "align": "center",
      "label": "销售类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.GoodActiveName
          }
        }, [_vm._v(_vm._s(scope.row.GoodActiveName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "BargainGoodsTypeName",
      "align": "center",
      "label": "商品类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.BargainGoodsTypeName
          }
        }, [_vm._v(_vm._s(scope.row.BargainGoodsTypeName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "BargainPrice",
      "align": "center",
      "label": "砍价总金额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.BargainPrice
          }
        }, [_vm._v(_vm._s(scope.row.BargainPrice))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "align": "center",
      "label": "砍价总人数"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.center
          }
        }, [_vm._v(_vm._s(scope.row.center))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "STime",
      "align": "center",
      "label": "生效日期"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.STime
          }
        }, [_vm._v(_vm._s(scope.row.STime))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ETime",
      "align": "center",
      "label": "失效日期"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.ETime
          }
        }, [_vm._v(_vm._s(scope.row.ETime))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "180",
      "fixed": "right",
      "prop": "",
      "align": "center",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.State == 1) ? _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.shangjia),
            expression: "shangjia"
          }],
          staticStyle: {
            "color": "#6786b4",
            "margin-left": "8px",
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.UpperShelf(scope)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-upload2"
        }), _vm._v("\n                      上架\n                ")]) : _vm._e(), _vm._v(" "), (scope.row.State == 2) ? _c('span', {
          staticStyle: {
            "color": "#6786b4",
            "margin-left": "8px",
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.updown(scope)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-download"
        }), _vm._v("\n                      强制下架\n                ")]) : _vm._e(), _vm._v(" "), (scope.row.State == 1) ? _c('span', {
          staticStyle: {
            "color": "#6786b4",
            "margin-left": "8px",
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.changeInfo(scope)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit-outline"
        }), _vm._v("\n                      修改\n                ")]) : _vm._e(), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.shuxing),
            expression: "shuxing"
          }],
          staticStyle: {
            "color": "#6786b4",
            "margin-left": "8px",
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.attribute(scope)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-tickets"
        }), _vm._v("\n                      属性\n                ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notconfigured),
      expression: "notconfigured"
    }],
    staticStyle: {
      "width": "98%",
      "height": "auto"
    },
    attrs: {
      "data": _vm.tableData,
      "align": "center",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "date",
      "type": "index",
      "align": "center",
      "label": "ID",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "align": "center",
      "label": "主图/商品名称",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticStyle: {
            "width": "50px",
            "height": "33px",
            "float": "left",
            "margin-left": "10px"
          },
          attrs: {
            "src": scope.row.FImgs
          }
        }), _vm._v(" "), _c('span', {
          staticStyle: {
            "display": "inline-block",
            "float": "left",
            "margin": "10px 0 0 5px",
            "width": "200px",
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.Title
          }
        }, [_vm._v(_vm._s(scope.row.Title))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "GoodModelCode",
      "align": "center",
      "label": "商品编码",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.GoodModelCode
          }
        }, [_vm._v(_vm._s(scope.row.GoodModelCode))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "amount2",
      "align": "center",
      "label": "所属城市"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.ProvinceName + '-' + scope.row.CityName
          }
        }, [_vm._v(_vm._s(scope.row.ProvinceName) + "-" + _vm._s(scope.row.CityName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "TzrPrice",
      "width": "130px",
      "align": "center",
      "label": "销售价格（元）"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": '￥' + scope.row.TzrPrice
          }
        }, [_vm._v("￥" + _vm._s(scope.row.TzrPrice))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "BrandName",
      "align": "center",
      "label": "品牌名称"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.BrandName
          }
        }, [_vm._v(_vm._s(scope.row.BrandName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "align": "center",
      "label": "商品分类"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.GoodsTypeName + '-' + scope.row.GoodsBrandTypeName
          }
        }, [_vm._v(_vm._s(scope.row.GoodsTypeName) + "-" + _vm._s(scope.row.GoodsBrandTypeName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "GoodActiveName",
      "align": "center",
      "label": "销售类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.GoodActiveName
          }
        }, [_vm._v(_vm._s(scope.row.GoodActiveName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "BargainGoodsTypeName",
      "align": "center",
      "label": "商品类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.BargainGoodsTypeName
          }
        }, [_vm._v(_vm._s(scope.row.BargainGoodsTypeName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "BargainPrice",
      "align": "center",
      "label": "砍价总金额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.BargainPrice
          }
        }, [_vm._v(_vm._s(scope.row.BargainPrice))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "align": "center",
      "label": "砍价总人数"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.center
          }
        }, [_vm._v(_vm._s(scope.row.center))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "STime",
      "align": "center",
      "label": "生效日期"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.STime
          }
        }, [_vm._v(_vm._s(scope.row.STime))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ETime",
      "align": "center",
      "label": "失效日期"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.ETime
          }
        }, [_vm._v(_vm._s(scope.row.ETime))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "prop": "",
      "align": "center",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "color": "#6786b4",
            "margin-left": "8px",
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.goconfigure(scope)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-setting"
        }), _vm._v("\n                      配置\n                ")])]
      }
    }])
  })], 1)], 1)], _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "10px",
      "margin-bottom": "10px",
      "margin-right": "30px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pageIndex,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.goconfigureshow),
      expression: "goconfigureshow"
    }]
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "goodsinfo"
  }, [_c('p', {
    staticClass: "oneinfo"
  }, [_c('span', {
    staticClass: "alignment"
  }, [_vm._v("商品主图：")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "120px",
      "height": "120px",
      "margin-top": "80px"
    },
    attrs: {
      "src": _vm.shopsrc
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "oneinfo"
  }, [_c('span', {
    staticClass: "alignment"
  }, [_vm._v("商品名称：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.shopname))])]), _vm._v(" "), _c('p', {
    staticClass: "oneinfo"
  }, [_c('span', {
    staticClass: "alignment"
  }, [_vm._v("商品编码：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.shopnumber))])]), _vm._v(" "), _c('p', {
    staticClass: "oneinfo"
  }, [_c('span', {
    staticClass: "alignment"
  }, [_vm._v("品牌名称：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.shopBbname))])]), _vm._v(" "), _c('p', {
    staticClass: "oneinfo"
  }, [_c('span', {
    staticClass: "alignment"
  }, [_vm._v("商品分类：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.shopType))])]), _vm._v(" "), _c('p', {
    staticClass: "oneinfo"
  }, [_c('span', {
    staticClass: "alignment"
  }, [_vm._v("所属城市：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.shopcity))])]), _vm._v(" "), _c('p', {
    staticClass: "oneinfo"
  }, [_c('span', {
    staticClass: "alignment"
  }, [_vm._v("销售类型：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.shopactive))])]), _vm._v(" "), _c('p', {
    staticClass: "oneinfo"
  }, [_c('span', {
    staticClass: "alignment"
  }, [_vm._v("商品类型：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.shoplexing))])]), _vm._v(" "), _c('p', {
    staticClass: "oneinfo"
  }, [_c('span', {
    staticClass: "alignment"
  }, [_vm._v("销售价格(元)：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.shopprice))])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "klanjia"
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    staticStyle: {
      "margin-left": "175px",
      "margin-bottom": "80px"
    },
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    staticClass: "input",
    attrs: {
      "label": "添加销售类型：",
      "prop": "name"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.shopactive))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "input",
    attrs: {
      "label": "添加商品类型：",
      "prop": "name"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.shoplexing))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "input",
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "label": "砍价总额：",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "onkeyup": "value=value.replace(/[^\\d\\.]/g,'').replace('.','')",
      "placeholder": "仅支持正整数，且为10的倍数"
    },
    model: {
      value: (_vm.BargainPrice),
      callback: function($$v) {
        _vm.BargainPrice = $$v
      },
      expression: "BargainPrice"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "input",
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "label": "前台显示最低价：",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "onkeyup": "value=value.replace(/[^\\d\\.]/g,'').replace('.','')",
      "placeholder": "销售价格-砍价总额"
    },
    model: {
      value: (_vm.ShowMinPrice),
      callback: function($$v) {
        _vm.ShowMinPrice = $$v
      },
      expression: "ShowMinPrice"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "input",
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "label": "最多砍价人次：",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "onkeyup": "value=value.replace(/[^\\d\\.]/g,'').replace('.','')",
      "placeholder": "2<=输入内容<=8"
    },
    model: {
      value: (_vm.MaxBargainNum),
      callback: function($$v) {
        _vm.MaxBargainNum = $$v
      },
      expression: "MaxBargainNum"
    }
  }), _vm._v("* 10\n          ")], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "input",
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "label": "参与砍价商品数量：",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "onkeyup": "value=value.replace(/[^\\d\\.]/g,'').replace('.','')",
      "placeholder": "请输入参与砍价商品数量"
    },
    model: {
      value: (_vm.Stock),
      callback: function($$v) {
        _vm.Stock = $$v
      },
      expression: "Stock"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "input",
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "label": "用户砍价有效时间",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": "请输入有效时间"
    },
    model: {
      value: (_vm.effectiveHour),
      callback: function($$v) {
        _vm.effectiveHour = $$v
      },
      expression: "effectiveHour"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "input",
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "label": "生效日期：",
      "prop": "name"
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "选择日期时间",
      "align": "right",
      "picker-options": _vm.pickerOptions1,
      "value-format": "yyyy-MM-dd HH:mm:ss"
    },
    model: {
      value: (_vm.STimepinzhi),
      callback: function($$v) {
        _vm.STimepinzhi = $$v
      },
      expression: "STimepinzhi"
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', {
    staticClass: "input",
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "label": "失效日期：",
      "prop": "name"
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "选择日期时间",
      "align": "right",
      "picker-options": _vm.pickerOptions2,
      "value-format": "yyyy-MM-dd HH:mm:ss"
    },
    model: {
      value: (_vm.ETimepinzhi),
      callback: function($$v) {
        _vm.ETimepinzhi = $$v
      },
      expression: "ETimepinzhi"
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "50px",
      "margin-left": "50px"
    }
  }, [_c('el-button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.resetForm()
      }
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('el-button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('el-button', {
    staticClass: "button1",
    on: {
      "click": function($event) {
        return _vm.quxiao()
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)])]), _vm._v(" "), _c('div', [_c('el-dialog', {
    staticStyle: {
      "margin-top": "150px"
    },
    attrs: {
      "title": _vm.Searchorreset ? '重置提示' : '错误提示',
      "visible": _vm.dialogVisible,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Searchorreset ? "是否重置所有的搜索项" : "请选择搜索条件查询"))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "findEr",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.Whether()
      }
    }
  }, [_vm._v(_vm._s(_vm.Searchorreset ? "是" : "确定"))]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Searchorreset),
      expression: "Searchorreset"
    }],
    staticClass: "findEr1",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("否")])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "margin-top": "150px"
    },
    attrs: {
      "title": "属性",
      "visible": _vm.dialogVisiblecha,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisiblecha = $event
      }
    }
  }, [_c('p', [_vm._v("\n        最后操作人：\n        "), _c('span', [_vm._v(_vm._s(_vm.OperatorName))])]), _vm._v(" "), _c('p', [_vm._v("\n        创建日期：\n        "), _c('span', [_vm._v(_vm._s(_vm.CTime))])]), _vm._v(" "), _c('p', [_vm._v("\n        修改日期：\n        "), _c('span', [_vm._v(_vm._s(_vm.LastUpdatorTime))])]), _vm._v(" "), _c('p', [_vm._v("\n        上架日期：\n        "), _c('span', [_vm._v(_vm._s(_vm.STime))])]), _vm._v(" "), _c('p', [_vm._v("\n        下架日期：\n        "), _c('span', [_vm._v(_vm._s(_vm.ETime))])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "findEr",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisiblecha = false
      }
    }
  }, [_vm._v("返回")])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "margin-top": "150px"
    },
    attrs: {
      "title": "开启提示",
      "visible": _vm.dialogVisibleshangjia,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisibleshangjia = $event
      }
    }
  }, [_c('P', [_vm._v("是否开启该商品砍价活动？")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "findEr",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.startActive()
      }
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-button', {
    staticClass: "findEr",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisibleshangjia = false
      }
    }
  }, [_vm._v("否")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "margin-top": "150px"
    },
    attrs: {
      "title": "强制下架提示",
      "visible": _vm.dialogVisiblexiajia,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisiblexiajia = $event
      }
    }
  }, [_c('P', [_vm._v("是否将该商品强制下线？")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "findEr",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.endActiveshow()
      }
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-button', {
    staticClass: "findEr",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisiblexiajia = false
      }
    }
  }, [_vm._v("否")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "margin-top": "150px"
    },
    attrs: {
      "title": "下架原因",
      "visible": _vm.dialogVisibleyuanyin,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisibleyuanyin = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    staticClass: "whyclose",
    attrs: {
      "label": "下架原因",
      "prop": "whyend"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入下架原因"
    },
    model: {
      value: (_vm.ruleForm.whyend),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "whyend", $$v)
      },
      expression: "ruleForm.whyend"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "findEr",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.endActive('ruleForm')
      }
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-button', {
    staticClass: "findEr",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.endActiveover('ruleForm')
      }
    }
  }, [_vm._v("否")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "margin-top": "150px"
    },
    attrs: {
      "title": "提示",
      "visible": _vm.dialogVisiblequxiao,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisiblequxiao = $event
      }
    }
  }, [_c('P', [_vm._v("是否取消编辑？ 若返回将不保存已配置内容")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "findEr",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.quxiaosure()
      }
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-button', {
    staticClass: "findEr",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisiblequxiao = false
      }
    }
  }, [_vm._v("否")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "margin-top": "150px"
    },
    attrs: {
      "title": "重置提示",
      "visible": _vm.dialogVisiblechongzhi,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisiblechongzhi = $event
      }
    }
  }, [_c('P', [_vm._v("是否重置？")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "findEr",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.chongzhisure()
      }
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-button', {
    staticClass: "findEr",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisiblechongzhi = false
      }
    }
  }, [_vm._v("否")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "margin-top": "150px"
    },
    attrs: {
      "title": "提示",
      "visible": _vm.dialogVisiblesure,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisiblesure = $event
      }
    }
  }, [_c('P', [_vm._v("是否确认提交？")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "findEr",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.peizhisure()
      }
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-button', {
    staticClass: "findEr",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisiblesure = false
      }
    }
  }, [_vm._v("否")])], 1)], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "goodslist1"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "21px",
      "margin-top": "5px"
    }
  }, [_vm._v("搜索/查询")]), _vm._v(" "), _c('span', {
    staticClass: "goods_red"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tittle"
  }, [_c('strong', {
    staticStyle: {
      "margin-left": "10px",
      "display": "inline-block",
      "height": "30px"
    }
  }, [_vm._v("配置")]), _vm._v(" "), _c('span', {
    staticClass: "wei"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('span', {
    staticClass: "red_info"
  }), _vm._v(" "), _c('strong', {
    staticStyle: {
      "margin-left": "5px",
      "margin-top": "-1px"
    }
  }, [_vm._v("商品信息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('span', {
    staticClass: "red_info"
  }), _vm._v(" "), _c('strong', {
    staticStyle: {
      "margin-left": "5px",
      "margin-top": "-1px"
    }
  }, [_vm._v("砍价配置")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b3daea42!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/staging/Configuration.vue
// module id = 1738
// module chunks = 3